import React from 'react';
import { Stethoscope } from 'lucide-react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  variant?: 'light' | 'dark';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  showText = true, 
  variant = 'dark',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'h-8 w-8',     // Increased from h-6 w-6 (24px to 32px = +33%)
    md: 'h-11 w-11',   // Increased from h-8 w-8 (32px to 44px = +37.5%)
    lg: 'h-16 w-16'    // Increased from h-12 w-12 (48px to 64px = +33%)
  };

  const textSizeClasses = {
    sm: 'text-lg',     // Increased from text-base
    md: 'text-xl',     // Increased from text-lg
    lg: 'text-3xl'     // Increased from text-2xl
  };

  const textColorClasses = {
    light: 'text-white',
    dark: 'text-gray-900'
  };

  const iconColorClass = variant === 'light' ? 'text-white' : 'text-dental-600';

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logo.png" 
        alt="Plannitas Logo" 
        className={`${sizeClasses[size]} object-contain flex-shrink-0`}
        onError={(e) => {
          // Fallback to icon if logo image fails to load
          e.currentTarget.style.display = 'none';
          const fallbackIcon = e.currentTarget.nextElementSibling as HTMLElement;
          if (fallbackIcon) {
            fallbackIcon.classList.remove('hidden');
          }
        }}
      />
      <Stethoscope className={`${sizeClasses[size]} ${iconColorClass} hidden flex-shrink-0`} />
      {showText && (
        <span className={`ml-2 font-bold ${textSizeClasses[size]} ${textColorClasses[variant]}`}>
          Plannitas
        </span>
      )}
    </div>
  );
};

export default Logo;